export default {"src":"/_next/static/media/BeGambleAware.c1fcef61.svg","height":40,"width":269,"blurWidth":0,"blurHeight":0};